import React, { useEffect, useState } from 'react';
import { Bar, ChartProps } from 'react-chartjs-2';
import { ChartData } from 'chart.js';
import ChartContainer from '@components/charts/ChartContainer';
import { LawsuitsCountsByMonth } from '@api/LawsuitService/getCountsByMonth';
import { months } from '@components/charts/common';
import getAxisMaxValue from '@utils/getAxisMaxValue';
import _ from 'lodash';
import moment from 'moment/moment';

const options = (dataLength: number): ChartProps<'bar'>['options'] => ({
  maintainAspectRatio: false,
  scales: {
    y: {
      ticks: {stepSize: 1},
      max: getAxisMaxValue(dataLength),
    },
  },
  plugins: {
    title: {
      display: true,
      text: 'Lawsuits By Month',
      font: {
        size: 20,
      },
    },
    legend: {
      display: false,
    },
  },
});

type LawsuitsByMonthProps = {
  data: LawsuitsCountsByMonth[] | null;
};

function LawsuitsByMonth({data}: LawsuitsByMonthProps) {
  const [chartData, setChartData] = useState<ChartData<'bar'> | null>(null);

  useEffect(() => {
    if (data) {
      setChartData({
        labels: months,
        datasets: [{
          data: months.map(m => {
            const currentMonthData: LawsuitsCountsByMonth | undefined =
              data.find(d => moment(m, 'MMM').isSame(moment(d.month, 'M')));
            return currentMonthData ? currentMonthData.count : null;
          }),
          backgroundColor: '#197CB6',
          barPercentage: 0.5,
        }],
      });
    } else {
      setChartData(null);
    }
  }, [data]);

  const maxYValue: number = _.max(data?.map(d => d.count)) || 0;

  return (
    <ChartContainer loading={!chartData}>
      <Bar data={chartData!} options={options(maxYValue)}/>
    </ChartContainer>
  );
}

export default React.memo(LawsuitsByMonth);
